export enum EShippingCalculationMethodType {
  None = 0,
  Api = 1,
  Fixed = 2,
  Free = 3,
}
